<div class="sh-wrap-text" *ngIf="record$ | async as record">
    <ng-container *ngIf="profiles$ | async as profiles">
        <ng-container *ngFor="let profile of profiles">
            <sh-profile-readonly-fieldset [profile]="profile" [record]="record" [aiProfile]="aiProfile"></sh-profile-readonly-fieldset>
        </ng-container>

        <sh-notification
            *ngIf="profiles.length === 0"
            [type]="notificationType.Error"
            [title]="'record-detail.notifications.no-profiles.title' | translate"
            [message]="'record-detail.notifications.no-profiles.message' | translate: { amount: 1 }"
            [icon]="'delete'"
        ></sh-notification>
    </ng-container>
</div>
